<template>
  <div id="addEdit">
    <el-dialog :title="formData.protocol_id?'编辑协议':'添加协议'" :visible.sync="visible" width="700px">
      <el-form :model="formData" size="small" label-width="80px" ref="formRef" :rules="rules">

        <el-form-item label="key" prop="key">
          <el-input v-model="formData.key" :disabled="formData.protocol_id==null?false:true"  placeholder="请输入key"></el-input>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="formData.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content">

          <Uediter v-if="ueShow" :config="config"  :text="formData.content"  v-model="formData.content" @contentChange="contentChangeFunc"></Uediter>


          <!-- <el-input v-model="formData.content" placeholder="请输入内容"></el-input> -->
        </el-form-item>

      </el-form>
      <div slot="footer"  class="dialog-footer">
        <el-button @click="visible=false">取消</el-button>
        <el-button type="primary" @click="submitForm" :loading="loading">提交</el-button>
      </div>
    </el-dialog>

  </div>
  </template>

  <script>
  import Uediter from '@/components/UE.vue';
  import SettingApi from '@/api/setting.js';
  export default {
    components:{Uediter},
    data(){
      return{
        ueShow:false,
        visible:false,
        detail:{},
        config: {
          initialFrameWidth: 580,
          initialFrameHeight: 500,
        },
        formData:{
          key:'',
          title:'',
          content:'',
        },
        rules:{
          key: [{ required: true, message: '请输入key', trigger: 'blur' }],
          title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
          content: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        },
        loading:false
      }
    },
    methods:{

      // 开启
      show(e){
        this.ueShow=false
        this.visible=true
        delete this.formData.protocol_id
        if(e&&e!=''){
          for(let i in this.formData){
            this.formData[i]=e[i]
          }
          this.formData.protocol_id=e.protocol_id
        }else{
          for(let i in this.formData){
            this.formData[i]=''
          }
        }
        this.$nextTick(()=>{
          this.ueShow=true
        })
        // this.detail=e
        // this.formData.apply_id=e.apply_id
      },

      // 提交
      submitForm(){
        this.$refs.formRef.validate(valid => {
          if (valid) {
            this.loading=true
            let API
            if(this.formData.protocol_id){
              API=SettingApi.protocolEdit
            }else{
              API=SettingApi.protocolAdd
            }
            API(this.formData).then(res=>{
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              this.visible=false
              this.$emit('refresh')
            }).finally(()=>{
              this.loading=false
            })

          }
        })
      },

      contentChangeFunc(e){
        this.formData.content=e
      },


    }

  }
  </script>

  <style lang="scss" scoped>
  ::v-deep .el-image{width: 50px;height: 50px;margin: 4px;}
  </style>



// WEBPACK FOOTER //
// src/views/setting/protocol/addEdit.vue